import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Constants } from '../../shared/models/constants';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class NotificationsCenterGridService {
    constructor() { }

    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], Constants.DATETIME_FORMAT, 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    sentErrorCellRenderer(rowData, field) {
        if (rowData[field] && rowData[field] === 'Error') {
            return `<div class="badge text-bg-danger rounded-1">` + rowData[field] + `</div>`;
        }
        if (rowData[field] && rowData[field] === 'Sent') {
            return `<div class="badge text-bg-success rounded-1">` + rowData[field] + `</div>`;
        }
        if (rowData[field] && rowData[field] === 'Pending') {
            return `<div class="badge rounded-1" style="background-color: #fb3 !important; color: #fff !important;">` + rowData[field] + `</div>`;
        }
        else {
            return `<div>` + rowData[field] + `</div>`;
        }
    }

    cols: Array<TableColumn> = [
        {
            field: 'emailRecipient',
            header: 'Email Recipient',
            sort: true,
            sortName: 'emailRecipient',
            filter: { type: FilterTypes.text },
            style: { 'width': '200px', 'min-width': '204px', 'max-width': '200px' }
        },
        {
            field: 'subject',
            header: 'Subject Line',
            sort: true,
            sortName: 'subject',
            filter: { type: FilterTypes.text },
            style: { 'width': '200px', 'min-width': '200px', 'max-width': '200px' }
        },
        {
            field: 'category',
            header: 'Email Type',
            sort: true,
            sortName: 'category',
            filter: {
                    type: FilterTypes.select, selectOptions: [
                        { label: 'All', value: '' },
                        { label: 'Certification', value: 'Certification' },
                        { label: 'General', value: 'General' },
                        { label: 'Project Study', value: 'Project Study' },                                            
                        { label: 'Prometric', value: 'Prometric' },                                                                    
                        { label: 'Quotation', value: 'Quotation' },
                        { label: 'Reminder', value: 'Reminder' },
                        { label: 'Report', value: 'Report' },
                        { label: 'Survey', value: 'Survey' },
                        { label: 'Tech Support', value: 'Tech Support' },
                        { label: 'Project Study', value: 'Project Study' }
                    ]
            }
        },
        {
            field: 'emailStatus',
            header: 'Status',
            sort: true,
            sortName: 'emailStatus',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.sentErrorCellRenderer
            }
        },
        {
            field: 'emailDate',
            header: 'Email Date',
            sort: true,
            sortName: 'emailDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'createdDate',
            header: 'Created Date',
            sort: true,
            sortName: 'createdDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'cc',
            header: 'CC',
            sort: true,
            sortName: 'cc',
            filter: { type: FilterTypes.text },
            style: { 'width': '180px', 'min-width': '180px', 'max-width': '180px' }
        },
        {
            field: 'bcc',
            header: 'BCC',
            sort: true,
            sortName: 'bcc',
            filter: { type: FilterTypes.text },
            style: { 'width': '180px', 'min-width': '180px', 'max-width': '180px' }
        }
    ];

}

